

































import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';

import type { SearchModulesModel } from '~/diptyqueTheme/types/contentful';

export default defineComponent({
  name: 'AutocompleteEmptyStateSidebar',
  components: {
    EditorialPushItem: () =>
      import('templates/sections/EditorialPush/EditorialPushItem.vue'),
    SectionHeading: () =>
      import(
        '@algolia-search/components/atoms/SectionHeading/SectionHeading.vue'
      ),
    LinksList: () =>
      import('@algolia-search/components/molecules/LinksList/LinksList.vue'),
    AutocompleteSectionBlock: () =>
      import(
        '@algolia-search/components/templates/SectionBlock/AutocompleteSectionBlock.vue'
      )
  },
  props: {
    contentfulData: {
      type: Object as PropType<SearchModulesModel> | null,
      default: null
    }
  },
  setup(props) {
    const aboutDiptyqueBlockHeading = computed(
      () => props.contentfulData?.aboutDiptyqueBlockHeading
    );
    const aboutDiptyqueBlockItem = computed(
      () => props.contentfulData?.aboutDiptyqueBlockItem
    );
    const customerServiceBlockHeading = computed(
      () => props.contentfulData?.customerServiceBlockHeading
    );
    const customerServiceBlockItems = computed(
      () => props.contentfulData?.customerServiceBlockItemsCollection?.items
    );

    return {
      aboutDiptyqueBlockHeading,
      aboutDiptyqueBlockItem,
      customerServiceBlockHeading,
      customerServiceBlockItems
    };
  }
});
